import React, { useState } from "react";
import UpdateInventoryForm from "./UpdateInventoryForm";
import UseTemplateForm from "./UseTemplateForm"; // Import your new component
import Tab from "../generic/Tab"; // Import your Tab component
import BulkUpdateInventoryForm from "./BulkUpdateInventoryForm";
import { UPDATE_INVENTORY_TABS } from "../../constants/TabTypes";

const TABS = UPDATE_INVENTORY_TABS;

const UpdateInventory: React.FC = () => {
    const [ activeTab, setActiveTab ] = useState<string>(TABS[0]); // Default to "Manual Update"

    return (
        <div>
            <div className={"py-8"}>
                <div>
                    {/* Tabs */}
                    <Tab
                        tabs={TABS}
                        activeTab={activeTab}
                        onTabChange={(tab) => setActiveTab(tab)} // Set active tab directly
                        mainTabStyle={"alt"}
                    />
                    {/* Tab Content */}
                    <div>
                        {activeTab === TABS[0] && (
                            <UpdateInventoryForm/>
                        )}
                        {activeTab === TABS[1] && (
                            <BulkUpdateInventoryForm/>
                        )}
                        {activeTab === TABS[2] && (
                            <UseTemplateForm/>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpdateInventory;
